import { fetchUtils } from "react-admin";
import dayjs from "dayjs";
import { placesApi, userApi } from "../url";

const httpClient = (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
    options.headers.set("Access-Control-Allow-Origin", "*");
  }
  if (localStorage.getItem("accessToken")) {
    options.headers.set(
      "Authorization",
      `Bearer ${localStorage.getItem("accessToken")}`,
    );
  }

  return fetchUtils.fetchJson(url, options);
};

const dataProvider = {
  create: (resource, params) => {
    return httpClient(`${userApi}/${resource}`, {
      method: "POST",
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({
      data: { ...params.data, id: json.result },
    }));
  },

  getList: (resource, params) => {
    const { sort } = params;
    // const url = `${api}/${resource}/all?skip=${(skip - 1) * limit}&limit=${limit}`;
    const search = new URLSearchParams();

    // Search params based on pagination
    if (params && params.meta && params.meta.nonPaginated) {
      search.set("nonPaginated", params.meta.nonPaginated);
    } else if (params.pagination) {
      if (params.pagination.page) {
        search.set("page", params.pagination.page);
      }
      if (params.pagination.perPage) {
        search.set("count", params.pagination.perPage || 25);
      } else {
        search.set("count", 25);
      }
      if (sort && sort.field) {
        search.set("orderBy", sort.field ?? "name");
      }
      if (sort && sort.order) {
        search.set("order", sort.order);
      }
    }
    // Search Params based on filters
    if (params.filter) {
      if (params.filter.like) {
        Object.keys(params.filter.like).forEach((key) => {
          console.log(params.filter.like[key]);
          if (!params.filter.like[key].includes("%")) {
            search.append(`like[${key}]`, `%${params.filter.like[key]}%`);
          } else {
            search.append(`like[${key}]`, params.filter.like[key]);
          }
        });
        delete params.filter.like;
      }
      if (params.filter.name) {
        search.append(`like[name]`, `%${params.filter.name}%`);
      }
      // if (params.filter.id) {
      //    if(params.filter.id instanceof Array){
      //      params.filter.id.forEach((it) => {
      //        search.append("id", it);
      //      })
      //    }
      // }
      Object.keys(params.filter).forEach((key) => {
        if (params.filter[key] instanceof Array) {
          params.filter[key].forEach((it) => {
            search.append(key, it);
          });
        } else {
          search.append(key, params.filter[key]);
        }
      });
    }
    if (params.meta && params.meta.filter) {
      Object.keys(params.meta.filter).forEach((key) => {
        search.append(key, params.meta.filter[key]);
      });
    }
    if (resource === "event") {
      return eventReadMany(params, search);
    }
    if (resource === "achievement") {
      return achievementReadMany(params, search);
    }

    if (resource === "painting") {
      return paintingReadMany(params, search);
    }

    if (resource === "parent") {
      return parentReadMany(params, search);
    }
    if (resource === "child") {
      return childReadMany(params, search);
    }
    if (resource === "story") {
      return storyReadMany(params, search);
    }
    if (resource === "pharmacy") {
      return pharmaciesReadMany(params, search);
    }
    if (resource === "coupon") {
      return couponReadMany(params, search);
    }
    if (resource === "seo") {
      return seoReadMany(params, search, "seo");
    }
    if (resource === "faq") {
      return faqReadMany(params, search);
    }
    if (resource === "altilium-seo") {
      return seoReadMany(params, search, "altilium-seo");
    }

    if (resource === "doctors") {
      if (params.filter.name) {
        return doctorReadManyByName(params.filter.name);
      }
      return doctorsReadMany(params, search);
    }

    if (resource === "youtube-video") {
      return youtubeVideoReadMany(params, search);
    }
    const url = `${userApi}/${resource}?${search.toString()}`;
    return httpClient(url)
      .then(({ headers, json }) => {
        return {
          data: json.result ?? json[resource] ?? json[resource + "s"] ?? [],
          total: json.count ?? 0,
        };
      })
      .catch(function (error) {
        if (
          error.status === 404 &&
          error.body &&
          typeof error.body === "object"
        ) {
          return {
            data: error.body.result ?? [],
            total: error.body?.result?.length() ?? 0,
          };
        }
        return {
          data: [],
          total: 0,
        };
      });
  },

  getOne: (resource, params) => {
    if (resource === "achievement") {
      return achievementReadOne(params.id);
    }
    if (resource === "event") {
      return eventReadOne(params.id);
    }
    if (resource === "seo") {
      return seoReadOne(params.id, "seo");
    }
    if (resource === "altilium-seo") {
      return seoReadOne(params.id, "altilium-seo");
    }
    if (resource === "faq") {
      return faqReadOne(params.id, "faq");
    }
    if (resource === "achievement") {
      return achievementReadOne(params.id);
    }
    if (resource === "painting") {
      return paintingReadOne(params.id);
    }
    if (resource === "story") {
      return storyReadOne(params.id);
    }
    if (resource === "doctors") {
      return doctorReadOne(params.id);
    }
    if (resource === "pharmacy") {
      return pharmacyReadOne(params.id);
    }

    return httpClient(`${userApi}/${resource}/${params.id}`).then(
      ({ json }) => ({
        data: json.result,
      }),
    );
  },

  getMany: (resource, params) => {
    const query = { id: params.ids };
    const search = new URLSearchParams();

    if (resource === "doctors") {
      const docs = doctorReadOne(params.ids[0]).then(({ data }) => {
        return { data: [data] };
      });
      return docs;
    }
    console.log("getMany", "provider", resource, params);
    if (resource === "parent") {
      if (params.ids.length === 1) {
        const docs = parentReadOne(params.ids[0]).then(({ data }) => {
          return { data: [data] };
        });
        return docs;
      } else {
        console.log("parentReadManyByIds", "provider", resource, params.ids);
        return parentReadManyByIds(params.ids);
      }
    }

    Object.keys(query).forEach((value) => {
      if (query[value] instanceof Array) {
        query[value].forEach((v) => search.append(value, v));
      } else {
        search.append(value, query[value]);
      }
    });
    search.append("nonPaginated", true);

    const url = `${userApi}/${resource}?${search.toString()}`;
    return httpClient(url).then(({ json }) => {
      if (resource === "child") {
        return { data: json.children };
      }

      return { data: json.result };
    });

    // const url = `${api}/${resource}?nonPaginated=true&${query.id}`
    // return httpClient(url).then(({ json }) => ({ data: json.result }));
  },

  update: (resource, params) => {
    console.log("update", "provider", resource, params);

    if (resource === "doctors") {
      return doctorUpdateOne(resource, params);
    }
    if (resource === "pharmacy") {
      return pharmacyUpdateOne(resource, params);
    }
    return httpClient(`${userApi}/${resource}/${params.id}`, {
      method: "PATCH",
      body: JSON.stringify(params.data),
    }).then(({ json }) => {
      console.log(params);
      return { data: { ...params.data, id: params.id } };
    });
  },

  delete: (resource, params) => {
    return httpClient(`${userApi}/${resource}/${params.id}`, {
      method: "DELETE",
    }).then(({ json }) => ({ data: json }));
  },

  getManyReference: (resource, params) => {
    const { sort } = params;
    // const url = `${api}/${resource}/all?skip=${(skip - 1) * limit}&limit=${limit}`;
    const search = new URLSearchParams();
    if (params.pagination) {
      if (!params.pagination.nonPaginated) {
        if (params.pagination.page) {
          search.set("page", params.pagination.page);
        }
        if (params.pagination.perPage) {
          search.set("count", params.pagination.perPage || 10);
        } else {
          search.set("count", 10);
        }
        if (sort.field) {
          search.set("orderBy", sort.field ?? "name");
        }
        if (sort.order) {
          search.set("order", sort.order);
        }
      } else {
        search.set("nonPaginated", false);
      }
    } else {
      search.set("nonPaginated", true);
    }
    if (params.target) {
      search.append(params.target, params.value || params.id);
    }
    return httpClient(`${userApi}/${resource}?${search.toString()}`, {
      method: "GET",
    }).then(({ json }) => {
      console.log(json, "dbfvhbsdhvbsdhvbshdbvsdhabasdhb");
      if (resource == "child") {
        return {
          data: json.children,
          total: json.count,
        };
      }
      return { data: json.result, total: json.count };
    });
  },

  bulkNotification: (params) => {
    console.log(JSON.stringify(params));
    return httpClient(`${userApi}/deviceInfo/notification`, {
      method: "POST",
      body: JSON.stringify(params.notification),
    }).then(({ json }) => ({
      data: { ...params.notification, id: "" },
    }));
  },
};

let _parentCache = null;
let _parentCacheTimestamp = null;
const PARENT_CACHE_TTL = 5 * 60 * 1000; // 5 minutes
let _prefetchPromise = null; // prevents duplicate in-flight requests

function isParentCacheFresh() {
  return (
    _parentCache &&
    _parentCacheTimestamp &&
    Date.now() - _parentCacheTimestamp < PARENT_CACHE_TTL
  );
}

export async function prefetchParents() {
  if (isParentCacheFresh()) return;
  if (_prefetchPromise) return _prefetchPromise;

  _prefetchPromise = httpClient(`${userApi}/parent/many?nonPaginated=true`, {
    method: "GET",
  })
    .then(({ json }) => {
      _parentCache = json.parents || [];
      _parentCacheTimestamp = Date.now();
    })
    .catch((err) => {
      console.error("Parent prefetch failed:", err);
    })
    .finally(() => {
      _prefetchPromise = null;
    });

  return _prefetchPromise;
}

export async function parentReadMany(_, search, nonPaginated = false) {
  const isSearch = search instanceof URLSearchParams;

  const emailFilter = isSearch ? search.get("email") : null;
  const mobileFilter = isSearch ? search.get("mobile") : null;
  const idFilters = isSearch ? search.getAll("id") : [];
  const createdDateFrom = isSearch ? search.get("createdDateFrom") : null;
  const createdDateTo = isSearch ? search.get("createdDateTo") : null;

  const hasAnyFilter =
    emailFilter || mobileFilter || idFilters.length > 0 || createdDateFrom || createdDateTo;

  if (hasAnyFilter && isSearch) {
    search.delete("email");
    search.delete("mobile");
    search.delete("id");
    search.delete("createdDateFrom");
    search.delete("createdDateTo");

    const page = parseInt(search.get("page") || "1", 10);
    const count = parseInt(search.get("count") || "25", 10);

    let allParents;
    if (isParentCacheFresh()) {
      allParents = _parentCache;
    } else {
      if (_prefetchPromise) {
        await _prefetchPromise;
      }
      if (isParentCacheFresh()) {
        allParents = _parentCache;
      } else {
        const { json } = await httpClient(
          `${userApi}/parent/many?nonPaginated=true`,
          { method: "GET" },
        );
        allParents = json.parents || [];
        _parentCache = allParents;
        _parentCacheTimestamp = Date.now();
      }
    }

    let filtered = allParents;

    if (emailFilter) {
      const q = emailFilter.toLowerCase();
      filtered = filtered.filter(
        (p) => p.email && p.email.toLowerCase().includes(q),
      );
    }

    if (mobileFilter) {
      const q = mobileFilter.replace(/\D/g, "");
      filtered = filtered.filter(
        (p) => p.mobile && p.mobile.replace(/\D/g, "").includes(q),
      );
    }

    if (idFilters.length > 0) {
      const idSet = new Set(idFilters.map((id) => id.trim()).filter(Boolean));
      filtered = filtered.filter((p) => idSet.has(p.id));
    }

    if (createdDateFrom) {
      const from = dayjs(createdDateFrom).startOf("day");
      filtered = filtered.filter(
        (p) =>
          p.createdDate &&
          dayjs(p.createdDate).isAfter(from.subtract(1, "second")),
      );
    }
    if (createdDateTo) {
      const to = dayjs(createdDateTo).endOf("day");
      filtered = filtered.filter(
        (p) =>
          p.createdDate &&
          dayjs(p.createdDate).isBefore(to.add(1, "second")),
      );
    }

    const total = filtered.length;
    const start = (page - 1) * count;
    const paged = filtered.slice(start, start + count);

    return { data: paged, total };
  }

  return httpClient(
    `${userApi}/parent/many?${search}&nonPaginated=${nonPaginated}`,
    {
      method: "GET",
    },
  ).then(({ json }) => ({ data: json.parents, total: json.count }));
}

export async function getFilteredParents(filters = {}) {
  let allParents;
  if (isParentCacheFresh()) {
    allParents = _parentCache;
  } else {
    if (_prefetchPromise) {
      await _prefetchPromise;
    }
    if (isParentCacheFresh()) {
      allParents = _parentCache;
    } else {
      const { json } = await httpClient(
        `${userApi}/parent/many?nonPaginated=true`,
        { method: "GET" },
      );
      allParents = json.parents || [];
      _parentCache = allParents;
      _parentCacheTimestamp = Date.now();
    }
  }

  let filtered = allParents;

  if (filters.email) {
    const q = filters.email.toLowerCase();
    filtered = filtered.filter(
      (p) => p.email && p.email.toLowerCase().includes(q),
    );
  }

  if (filters.mobile) {
    const q = filters.mobile.replace(/\D/g, "");
    filtered = filtered.filter(
      (p) => p.mobile && p.mobile.replace(/\D/g, "").includes(q),
    );
  }

  if (filters.id && filters.id.length > 0) {
    const idSet = new Set(filters.id.map((id) => id.trim()).filter(Boolean));
    filtered = filtered.filter((p) => idSet.has(p.id));
  }

  if (filters.createdDateFrom) {
    const from = dayjs(filters.createdDateFrom).startOf("day");
    filtered = filtered.filter(
      (p) =>
        p.createdDate &&
        dayjs(p.createdDate).isAfter(from.subtract(1, "second")),
    );
  }
  if (filters.createdDateTo) {
    const to = dayjs(filters.createdDateTo).endOf("day");
    filtered = filtered.filter(
      (p) =>
        p.createdDate &&
        dayjs(p.createdDate).isBefore(to.add(1, "second")),
    );
  }

  return { data: filtered, total: filtered.length };
}

export async function parentActive() {
  return httpClient(`${userApi}/parent/active`, {
    method: "GET",
  }).then(({ json }) => ({ data: json.parents, total: json.count }));
}
export async function parentReadManyByIds(ids) {
  return httpClient(`${userApi}/parent/readMany`, {
    method: "POST",
    body: JSON.stringify({ ids }),
  }).then(({ json }) => ({ data: json.parents, total: json.count }));
}

export async function couponReadMany(_, search, nonPaginated = false) {
  return httpClient(
    `${userApi}/coupon?${search}&nonPaginated=${nonPaginated}`,
    {
      method: "GET",
    },
  ).then(({ json }) => ({ data: json.coupons, total: json.count }));
}

async function childReadMany(_, search) {
  return httpClient(`${userApi}/child?${search}`, {
    method: "GET",
  }).then(({ json }) => ({ data: json.children, total: json.count }));
}

async function storyReadMany(_, search) {
  return httpClient(`${userApi}/story?${search}`, {
    method: "GET",
  }).then(({ json }) => ({ data: json.stories, total: json.count }));
}

async function doctorsReadMany(_, search) {
  return httpClient(`${placesApi}/doctors/many?${search}`, {
    method: "GET",
  }).then(({ json }) => ({
    data: json.places.map((resource) => ({ ...resource, id: resource._id })),
    total: json.count,
  }));
}

async function pharmaciesReadMany(_, search) {
  return httpClient(`${placesApi}/pharmacy/many?${search}`, {
    method: "GET",
  }).then(({ json }) => ({
    data: json.places.map((resource) => ({ ...resource, id: resource._id })),
    total: json.count,
  }));
}

async function eventReadMany(_, search) {
  return httpClient(`${userApi}/event?${search}`, {
    method: "GET",
  }).then(({ json }) => ({ data: json.events, total: json.count }));
}

async function seoReadMany(_, search, url) {
  return httpClient(`${userApi}/${url}?${search}`, {
    method: "GET",
  }).then(({ json }) => ({ data: json.seoDatas, total: json.count }));
}

async function faqReadMany(_, search) {
  return httpClient(`${userApi}/faq`, {
    method: "GET",
  }).then(({ json }) => ({ data: json.faqs, total: json.count }));
}
async function achievementReadMany(_, search) {
  return httpClient(`${userApi}/achievement?${search}`, {
    method: "GET",
  }).then(({ json }) => ({ data: json.events, total: json.count }));
}

async function youtubeVideoReadMany(_, search) {
  return httpClient(`${userApi}/youtube-video`, {
    method: "GET",
  }).then(({ json }) => ({ data: json.result, total: json.count }));
}

async function eventReadOne(id) {
  return httpClient(`${userApi}/event/${id}`, {
    method: "GET",
  }).then(({ json }) => ({ data: json.event }));
}

async function seoReadOne(id, url) {
  return httpClient(`${userApi}/${url}/${id}`, {
    method: "GET",
  }).then(({ json }) => ({ data: json.seoData }));
}
async function faqReadOne(id) {
  return httpClient(`${userApi}/faq/${id}`, {
    method: "GET",
  }).then(({ json }) => ({ data: json.faq }));
}
async function achievementReadOne(id) {
  return httpClient(`${userApi}/achievement/${id}`, {
    method: "GET",
  }).then(({ json }) => ({ data: json.event }));
}

async function paintingReadMany(_, search) {
  return httpClient(`${userApi}/painting?${search}`, {
    method: "GET",
  }).then(({ json }) => ({ data: json.paintings, total: json.count }));
}

async function paintingReadOne(id) {
  return httpClient(`${userApi}/painting/${id}`, {
    method: "GET",
  }).then(({ json }) => ({ data: json.painting }));
}

async function storyReadOne(id) {
  return httpClient(`${userApi}/story/${id}`, {
    method: "GET",
  }).then(({ json }) => ({ data: json.story }));
}

async function doctorReadOne(id) {
  return httpClient(`${placesApi}/doctors/id/${id}`, {
    method: "GET",
  }).then(({ json }) => ({ data: { ...json.place, id: json.place._id } }));
}

async function parentReadOne(id) {
  return httpClient(`${userApi}/parent/read/${id}`, {
    method: "GET",
  })
    .then(({ json }) => ({ data: { ...json.parent, id: json.parent.id } }))
    .catch((err) => {
      return {
        data: { id: id, name: "Deleted", email: "Deleted", mobile: "Deleted" },
      };
    });
}

async function pharmacyReadOne(id) {
  return httpClient(`${placesApi}/pharmacy/id/${id}`, {
    method: "GET",
  }).then(({ json }) => ({ data: { ...json.place, id: json.place._id } }));
}

async function pharmacyUpdateOne(_, params) {
  return httpClient(`${placesApi}/pharmacy/id/${params.id}`, {
    method: "PUT",
    body: JSON.stringify(params.body),
  }).then(({ json }) => ({ data: { ...params.data, id: params._id } }));
}

async function doctorUpdateOne(_, params) {
  console.log(JSON.stringify(params.data));
  return httpClient(`${placesApi}/doctors/id/${params.id}`, {
    method: "PUT",
    body: JSON.stringify(params.data),
  }).then(({ json }) => ({ data: { ...params.data, id: params._id } }));
}

async function doctorReadManyByName(name) {
  return httpClient(`${placesApi}/doctors/text?query=${name}`, {
    method: "GET",
  }).then(({ json }) => ({
    data: json.places.map((resource) => ({ ...resource, id: resource._id })),
    total: json.count,
  }));
}

export default dataProvider;
